import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import {
  breadcrumbsPageData,
  findPageKey,
  locationPath,
} from '../../constants/app-routes';
import NavBar from '../Layout/NavBar';
import Navigation from '../Layout/Navigation';
import Breadcrumbs from '../Reusable/Breadcrumbs';

import { PuffLoader } from 'react-spinners';
import {
  clearMonitoringLastSynchronization,
  fetchMonitoringLastSynchronization,
} from '../../actions/monitoring';
import { formatDateWithTimestamp } from '../../utils/date';

const ThemeWrapper = (props) => {
  const { translationsReducer, monitoringReducer } = useSelector((state) => ({
      translationsReducer: state.translationsReducer,
      monitoringReducer: state.monitoringReducer,
    })),
    { translations, loading: translationLoading } = translationsReducer || {},
    { menu_items, Monitoring } = translations || {},
    { lastSynchronizationDate, loading: monitoringLoading } =
      monitoringReducer || {};
  const dispatch = useDispatch();
  const history = useHistory();

  const currentPath = history.location.pathname;

  const isMonitoringPage = currentPath === locationPath.MONITORING;
  const lastSyncDate =
    lastSynchronizationDate && formatDateWithTimestamp(lastSynchronizationDate);

  useEffect(() => {
    isMonitoringPage &&
      dispatch(
        fetchMonitoringLastSynchronization(Monitoring?.NotificationMessages)
      );
    return () => {
      dispatch(clearMonitoringLastSynchronization());
    };
  }, [Monitoring?.NotificationMessages, isMonitoringPage, dispatch]);

  const getBreadcrumbsData = () => {
    return breadcrumbsPageData(
      findPageKey(currentPath),
      translations.menu_items
    );
  };

  const getBreadcrumbsCurrentPage = () => {
    const currentPageList = breadcrumbsPageData(
      findPageKey(currentPath),
      translations.menu_items
    );

    const currentPage = currentPageList[currentPageList.length - 1];

    return currentPage.name;
  };

  return (
    <Fragment>
      <Navigation />
      <NavBar />
      <div className="pcoded-main-container pcoded-custom-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="breadcumb-content">
              <div className="breadcrumb-line">
                <div className="breadcrumb-line-title-page">
                  <h5>{getBreadcrumbsCurrentPage()}</h5>
                </div>
                <div className="breadcrumb-line-path-page">
                  <Breadcrumbs data={getBreadcrumbsData()} />
                </div>
              </div>
            </div>
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div
                  hidden={!isMonitoringPage}
                  className="monitoring-sync-content-col px-1"
                >
                  {monitoringLoading ? (
                    <PuffLoader
                      color="#1dc4e9"
                      loading={!!monitoringLoading}
                      size={25}
                    />
                  ) : (
                    lastSyncDate && (
                      <div className="small-font wrapper-fade-in-short">
                        <label>{Monitoring?.label}:</label>&nbsp;
                        <span className="text-bold">{lastSyncDate}</span>
                      </div>
                    )
                  )}
                </div>
                <div className="page-wrapper">{props.children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ThemeWrapper;
